import { TokenBody } from '@cigna/shared/angular/auth/oidc-util';
export const JWT_NS = 'https://cignaforbrokers.cigna.com';

export interface AccessToken extends TokenBody {
  [JWT_NS]: {
    sessionId: string;
    email: string;
    firstName: string;
    middleName: string;
    lastName: string;
    mobile: string;
    phone: string;
    ssoId: string;
    userAgreementAccepted: boolean;
    lastAccessedInternalProcGrpId: number;
    uid: number;
  };
}
